import { IPostBlog } from 'src/app/interfaces/IPostBlog';
import { IPostBlogs } from '../interfaces/IPostBlog';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { map, retry } from 'rxjs/operators';
import { IComment, IComments } from '../interfaces/IComment';
import { ILike } from '../interfaces/ILike';
import { ICommentLike, IUserLikes } from '../interfaces/IUserLikes';
import { inject, Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class BlogService {
    private readonly http: HttpClient = inject(HttpClient);
    urlApi = environment.urlApi;
    communicationsList: BehaviorSubject<IPostBlog[]> = new BehaviorSubject([]);
    tutorialsList: BehaviorSubject<IPostBlog[]> = new BehaviorSubject([]);

    constructor() {}

    /***** OFFERTE *****/
    getAllDealComments(idOfferta, noLoading?): Observable<any> {
        let myLink = this.urlApi + environment.DEAL_COMMENT_GET_ALL + '/' + idOfferta;
        if (noLoading) {
            myLink = this.urlApi + environment.DEAL_COMMENT_GET_ALL_NO_LOADING + '/' + idOfferta;
        }
        return this.http.get<IComments>(myLink).pipe(
            retry({ count: 5, delay: 1000 }),
            map(res => res.data),
        );
    }

    createDealComment(comment: IComment): Observable<any> {
        const myLink = this.urlApi + environment.DEAL_COMMENT_CREATE_OR_UPDATE;
        return this.http.post<any>(myLink, comment).pipe(
            retry({ count: 5, delay: 1000 })
        );
    }

    deleteDealComment(id): Observable<any> {
        const myLink = this.urlApi + environment.DEAL_COMMENT_DELETE + '/' + id;
        return this.http.delete<string>(myLink).pipe(
            retry({ count: 5, delay: 1000 })
        );
    }

    deleteDealCommentFromAdmin(id, idUser): Observable<any> {
        const myLink = this.urlApi + environment.DEAL_COMMENT_DELETE_FROM_ADMIN + '/' + id + '/' + idUser;
        return this.http.delete<string>(myLink).pipe(
            retry({ count: 5, delay: 1000 })
        );
    }

    reportDealComment(id): Observable<any> {
        const myLink = this.urlApi + environment.DEAL_COMMENT_REPORT + '/' + id;
        return this.http.get<string>(myLink).pipe(
            retry({ count: 5, delay: 1000 })
        );
    }

    createDealLike(like: ILike): Observable<any> {
        const myLink = this.urlApi + environment.DEAL_LIKE_CREATE;
        return this.http.post<any>(myLink, like).pipe(
            retry({ count: 5, delay: 1000 })
        );
    }

    deleteDealLike(like: ILike): Observable<any> {
        const myLink = this.urlApi + environment.DEAL_LIKE_DELETE + '/' + like.id;
        return this.http.delete<any>(myLink).pipe(
            retry({ count: 5, delay: 1000 })
        );
    }

    createDealCommentLike(like: ICommentLike): Observable<any> {
        const myLink = this.urlApi + environment.DEAL_COMMENT_LIKE_CREATE;
        return this.http.post<any>(myLink, like).pipe(
            retry({ count: 5, delay: 1000 })
        );
    }

    deleteDealCommentLike(like: ILike): Observable<any> {
        const myLink = this.urlApi + environment.DEAL_COMMENT_LIKE_DELETE + '/' + like.idObj;
        return this.http.delete<any>(myLink).pipe(
            retry({ count: 5, delay: 1000 })
        );
    }

    /***** COMUNICAZIONI *****/
    getAllCommunications(firstAccess?): Observable<any> {
        let myLink = this.urlApi + environment.COMMUNICATION_GET_ALL;
        if (firstAccess) {
            myLink = this.urlApi + environment.COMMUNICATION_GET_ALL_FIRST_ACCESS;
        }
        return this.http.get<IPostBlogs>(myLink).pipe(
            retry({ count: 5, delay: 1000 }),
            map(res => res.data),
        );
    }

    getAllCommunicationComment(id): Observable<any> {
        const myLink = this.urlApi + environment.COMMUNICATION_COMMENT_GET_ALL + '/' + id;
        return this.http.get<IComments>(myLink).pipe(
            retry({ count: 5, delay: 1000 }),
            map(res => res.data),
        );
    }

    createCommunicationComment(comment: IComment): Observable<any> {
        const myLink = this.urlApi + environment.COMMUNICATION_COMMENT_CREATE_OR_UPDATE;
        return this.http.post<any>(myLink, comment).pipe(
            retry({ count: 5, delay: 1000 })
        );
    }

    deleteCommunicationComment(id): Observable<any> {
        const myLink = this.urlApi + environment.COMMUNICATION_COMMENT_DELETE + '/' + id;
        return this.http.delete<string>(myLink).pipe(
            retry({ count: 5, delay: 1000 })
        );
    }

    deleteCommunicationCommentFromAdmin(id, idUser): Observable<any> {
        const myLink = this.urlApi + environment.COMMUNICATION_COMMENT_DELETE_FROM_ADMIN + '/' + id + '/' + idUser;
        return this.http.delete<string>(myLink).pipe(
            retry({ count: 5, delay: 1000 })
        );
    }

    reportCommunicationComment(id): Observable<any> {
        const myLink = this.urlApi + environment.COMMUNICATION_COMMENT_REPORT + '/' + id;
        return this.http.get<string>(myLink).pipe(
            retry({ count: 5, delay: 1000 })
        );
    }

    createCommunicationLike(like: ILike): Observable<any> {
        const myLink = this.urlApi + environment.COMMUNICATION_LIKE_CREATE;
        return this.http.post<any>(myLink, like).pipe(
            retry({ count: 5, delay: 1000 })
        );
    }

    deleteCommunicationLike(like: ILike): Observable<any> {
        const myLink = this.urlApi + environment.COMMUNICATION_LIKE_DELETE + '/' + like.id;
        return this.http.delete<any>(myLink).pipe(
            retry({ count: 5, delay: 1000 })
        );
    }

    createCommunicationCommentLike(like: ICommentLike): Observable<any> {
        const myLink = this.urlApi + environment.COMMUNICATION_COMMENT_LIKE_CREATE;
        return this.http.post<any>(myLink, like).pipe(
            retry({ count: 5, delay: 1000 })
        );
    }

    deleteCommunicationCommentLike(like: ILike): Observable<any> {
        const myLink = this.urlApi + environment.COMMUNICATION_COMMENT_LIKE_DELETE + '/' + like.idObj;
        return this.http.delete<any>(myLink).pipe(
            retry({ count: 5, delay: 1000 })
        );
    }

    /***** TUTORIALS *****/
    getAllTutorials(firstAccess?): Observable<any> {
        let myLink = this.urlApi + environment.TUTORIAL_GET_ALL;
        if (firstAccess) {
            myLink = this.urlApi + environment.TUTORIAL_GET_ALL_FIRST_ACCESS;
        }
        return this.http.get<IPostBlogs>(myLink).pipe(
            retry({ count: 5, delay: 1000 }),
            map(res => res.data),
        );
    }

    getAllTutorialComments(id): Observable<any> {
        const myLink = this.urlApi + environment.TUTORIAL_COMMENT_GET_ALL + '/' + id;
        return this.http.get<IComments>(myLink).pipe(
            retry({ count: 5, delay: 1000 }),
            map(res => res.data),
        );
    }

    createTutorialLike(like: ILike): Observable<any> {
        const myLink = this.urlApi + environment.TUTORIAL_LIKE_CREATE;
        return this.http.post<any>(myLink, like).pipe(
            retry({ count: 5, delay: 1000 })
        );
    }

    deleteTutorialLike(like: ILike): Observable<any> {
        const myLink = this.urlApi + environment.TUTORIAL_LIKE_DELETE + '/' + like.id;
        return this.http.delete<any>(myLink).pipe(
            retry({ count: 5, delay: 1000 })
        );
    }

    createTutorialComment(comment: IComment): Observable<any> {
        const myLink = this.urlApi + environment.TUTORIAL_COMMENT_CREATE_OR_UPDATE;
        return this.http.post<any>(myLink, comment).pipe(
            retry({ count: 5, delay: 1000 })
        );
    }

    deleteTutorialComment(id): Observable<any> {
        const myLink = this.urlApi + environment.TUTORIAL_COMMENT_DELETE + '/' + id;
        return this.http.delete<string>(myLink).pipe(
            retry({ count: 5, delay: 1000 })
        );
    }

    deleteTutorialCommentFromAdmin(id, idUser): Observable<any> {
        const myLink = this.urlApi + environment.TUTORIAL_COMMENT_DELETE_FROM_ADMIN + '/' + id + '/' + idUser;
        return this.http.delete<string>(myLink).pipe(
            retry({ count: 5, delay: 1000 })
        );
    }

    reportTutorialComment(id): Observable<any> {
        const myLink = this.urlApi + environment.TUTORIAL_COMMENT_REPORT + '/' + id;
        return this.http.get<string>(myLink).pipe(
            retry({ count: 5, delay: 1000 })
        );
    }

    createTutorialCommentLike(like: ICommentLike): Observable<any> {
        const myLink = this.urlApi + environment.TUTORIAL_COMMENT_LIKE_CREATE;
        return this.http.post<any>(myLink, like).pipe(
            retry({ count: 5, delay: 1000 })
        );
    }

    deleteTutorialCommentLike(like: ILike): Observable<any> {
        const myLink = this.urlApi + environment.TUTORIAL_COMMENT_LIKE_DELETE + '/' + like.idObj;
        return this.http.delete<any>(myLink).pipe(
            retry({ count: 5, delay: 1000 })
        );
    }

    /***** LIKES LIST *****/
    getAllUserLikes(): Observable<any> {
        const myLink = this.urlApi + environment.USER_LIKE_GET_ALL;
        return this.http.get<IUserLikes>(myLink).pipe(
            retry({ count: 5, delay: 1000 }),
            map((res: any) => res.data)
        );
    }
}
